import { useEffect } from 'react';
import { onAuthStateChanged, User } from 'firebase/auth';
import { auth } from '@/lib/firebase/initialize';
import { useAppDispatch } from '@/lib/redux/store';
import {
  setFirebaseAccessToken,
  setIsUserloading,
  setUser as setReduxUser,
} from '@/lib/redux/app.slice';
import { useSelector } from 'react-redux';
import { selectIsTokenVerified } from '@/lib/redux/app.selectors';

const useInitializeFirebaseAuth = () => {
  const dispatch = useAppDispatch();
  const isTokenVerified = useSelector(selectIsTokenVerified);

  // on Load
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (isTokenVerified) {
        if (user) {
          dispatch(setReduxUser(user ? (user.toJSON() as User) : null));
          const token = await user.getIdToken();
          dispatch(setFirebaseAccessToken(token));
        } else {
          dispatch(setReduxUser(null));
          dispatch(setFirebaseAccessToken(''));
        }
      }
      dispatch(setIsUserloading(false));
    });

    return () => unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTokenVerified]);
};

export default useInitializeFirebaseAuth;
